<template lang="html">
  <h1>Did you already know Progressive?</h1>
  <div class="d-grid gap-2">
    <button
      type="button"
      class="btn btn-secondary text-light btn-lg"
      @click="setQuestionOne(true)"
    >
      Yes
    </button>
    <button
      type="button"
      class="btn btn-secondary text-light btn-lg"
      @click="setQuestionOne(false)"
    >
      No
    </button>
  </div>
</template>

<script>
export default {
  name: "QuestionOneScreen",
  data: () => ({}),
  computed: {},
  methods: {
    setQuestionOne(answer) {
      this.$store.commit("setQuestionOne", answer);
    },
  },
};
</script>

<style lang="css" scoped>
h1 {
  font-size: 40px;
  color: #6bc1d0;
}
.field {
  /* text-transform: uppercase; */
  margin: auto;
  outline: none;
  border: none;
  width: 90%;
  padding: 10px;
  font-size: 40px;
  border-radius: 0px;
  text-align: center;
  margin-bottom: 20px;
}
</style>
